import React, { useEffect, useRef } from "react";
import downloadWhite from "images/downloadWhite.svg";
import uploadWhite from "images/uploadWhite.svg";
import { Button } from "@material-ui/core";
import Table from "./Table";
import "../../../style.css";
import SearchIcon from "@material-ui/icons/Search";
import { InputAdornment } from "@material-ui/core";
import { CustomTextField } from "containers/gstr2a2bNewEnhancement/Utility/utility";
import { useDispatch, useSelector } from "react-redux";
import {
  downloadExcelUploadReport,
  getRecoTablesData,
  getUploadReportData,
  onCallUpload,
  setPageNoUploadReport,
  setSearchStr,
} from "../../action";
import { COMMON_MSGS } from "Constant/Messages";
import * as XLSX from "xlsx";
import { errorToastMessage } from "utils/errorToast";

const UploadReport = (props) => {
  const pollRef = useRef(null);
  const latestArgsRef = useRef({ pageNo: 1, search: "", isToast: true });

  const dispatch = useDispatch();
  const inputRef = useRef(null);
  const debounceTimeout = useRef(null);
  const { searchStr, pageNoUploadReport } = useSelector(
    (store) => store.gstr2a2bNewRecoReducer
  );

  // const handleDownload = () => {
  //   dispatch(downloadExcelUploadReport(viewRecoTableData));
  // };

  const handleInputChange = (event) => {
    const value = event.target.value;
    dispatch(setSearchStr(value));
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }
    clearPoll();
    debounceTimeout.current = setTimeout(() => {
      getFileData(value, 1, false);
    }, 500);
  };

  const onUploadButton = () => {
    inputRef.current?.click();
  };

  const onFileSelected = async (event) => {
    const file = event.target.files[0];

    if (!file) {
      errorToastMessage("No file selected.");
      return false;
    }

    if (!file.name.endsWith(".xlsx") && !file.name.endsWith(".xls")) {
      errorToastMessage(COMMON_MSGS.UPLOAD_FILE_TYPE);
      return false;
    }

    const today = new Date();
    const date = `${today.getDate()}-${
      today.getMonth() + 1
    }-${today.getFullYear()}`;
    const time = `${today.getHours()}-${today.getMinutes()}-${today.getSeconds()}`;
    const appendFile = `${date}_${time}_${file.name}`;

    try {
      const reader = new FileReader();
      // reader.readAsBinaryString(file);
      reader.readAsArrayBuffer(file);

      // reader.onerror = () => {
      //   errorToastMessage("Failed to read the file.");
      // };
      reader.onload = async (e) => {
        const data = e.target.result;
        // const readedData = XLSX.read(data, { type: "binary" });

        const readedData = XLSX.read(new Uint8Array(e.target.result), {
          type: "array",
        });
        reader.onerror = () => {
          errorToastMessage("Failed to read the file.");
        };
        const ws = readedData.Sheets["Summary"];
         const ws1 = readedData.Sheets["Invoice level"];

        if (ws1 == undefined) {
          errorToastMessage("Please upload valid file");
          return;
        }
        const dataParse = XLSX.utils.sheet_to_json(ws1, { header: 1 });

        console.log(dataParse,"dataParse")
        if (dataParse[0].length == 0) {
          errorToastMessage("Upload file can’t be blank");
          return;
        }

        // Check if headers are present but no data rows below
        if (
          dataParse.length <= 1 ||
          !dataParse
            .slice(1)
            .some((row) =>
              row.some((cell) => cell !== undefined && cell !== "")
            )
        ) {
          errorToastMessage("Upload file can’t be blank");
          return;
        }
        if (readedData) {
          const formData = new FormData();
          formData.append("upfile", file);
          formData.append("filename", appendFile);

          await dispatch(onCallUpload(formData));
          await getFileData(searchStr, 1, false);
        }
      };
    } catch (error) {
      errorToastMessage("An error occurred while reading the file.");
      console.error("File read error:", error);
    }
  };

  //   const handlePageClick = (value) => {
  //     if (debounceTimeout.current) {
  //         clearTimeout(debounceTimeout.current);

  //       }
  //     dispatch(setPageNoUploadReport(value.selected + 1));
  //     getFileData(searchStr, value.selected + 1, false);
  //   };
  //  async function getFileData(search = "", pageNo=pageNoUploadReport, isToast = true) {
  //     console.log("1st time pageNo:", pageNo);
  //     console.log("1st time search:", search);
  //     var fileDataTemp = await dispatch(
  //       getUploadReportData(pageNo, search, isToast)
  //     );
  //     let interval;
  //     let inProcessStatusCount = 0;
  //     fileDataTemp?.map((item) => {
  //       if (
  //         item.UPLOAD_STATUS?.toUpperCase() !== "COMPLETED" &&
  //         item.UPLOAD_STATUS?.toUpperCase() !== "FAILED"
  //       ) {
  //         inProcessStatusCount = inProcessStatusCount + 1;
  //       }
  //     });
  //     if (fileDataTemp?.length > 0 && inProcessStatusCount > 0) {
  //       interval = setInterval(async () => {
  //         let inProcessStatusCount = 0;
  //         fileDataTemp.map(async (item) => {
  //           if (
  //             item.UPLOAD_STATUS?.toUpperCase() !== "COMPLETED" &&
  //             item.UPLOAD_STATUS?.toUpperCase() !== "FAILED"
  //           ) {
  //             inProcessStatusCount = inProcessStatusCount + 1;
  //           }
  //         });
  //         if (inProcessStatusCount === 0) {
  //           clearInterval(interval);
  //         } else {
  //           console.log("else pageNo:", pageNo);
  //           console.log("else search:", search);
  //           fileDataTemp = await dispatch(
  //             getUploadReportData(pageNo, search, false)
  //           );
  //         }
  //       }, 10000);
  //     }
  //   }

  // at component top

  const clearPoll = () => {
    if (pollRef.current) {
      clearInterval(pollRef.current);
      pollRef.current = null;
    }
  };

  const inProcessCount = (rows = []) =>
    rows.filter((r) => {
      const s = r.UPLOAD_STATUS?.toUpperCase();
      return s !== "COMPLETED" && s !== "FAILED";
    }).length;

  const handlePageClick = (value) => {
    if (debounceTimeout.current) clearTimeout(debounceTimeout.current);

    const nextPage = value.selected + 1;

    // stop any previous polling tied to an old pageNo
    clearPoll();

    dispatch(setPageNoUploadReport(nextPage));
    getFileData(searchStr, nextPage, false);
  };

  async function getFileData(
    search = "",
    pageNo = pageNoUploadReport,
    isToast = true
  ) {
    // remember the latest args for the poller
    latestArgsRef.current = { pageNo, search, isToast };

    console.log("1st time pageNo:", pageNo);
    console.log("1st time search:", search);

    let fileDataTemp = await dispatch(
      getUploadReportData(pageNo, search, isToast)
    );

    // (optional) guard against undefined
    if (!Array.isArray(fileDataTemp)) fileDataTemp = [];

    const count = inProcessCount(fileDataTemp);

    if (fileDataTemp.length > 0 && count > 0) {
      // ensure only one active poller
      clearPoll();

      pollRef.current = setInterval(async () => {
        // always use the latest values, not stale closures
        const { pageNo: currPage, search: currSearch } = latestArgsRef.current;

        console.log("poll pageNo:", currPage);
        console.log("poll search:", currSearch);

        let data = await dispatch(
          getUploadReportData(currPage, currSearch, false)
        );
        if (!Array.isArray(data)) data = [];

        const stillProcessing = inProcessCount(data) > 0;
        if (!stillProcessing) clearPoll();
      }, 10000);
    } else {
      clearPoll();
    }
  }

  // clean up on unmount
  useEffect(() => () => clearPoll(), []);

  useEffect(() => {
    return () => {
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }
      dispatch(setSearchStr(""));
    };
  }, []);

  useEffect(() => {
    getFileData("", 1);
  }, []);

  return (
    <>
      <div style={{ display: "flex", justifyContent: "flex-start" }}>
        <div style={{ width: "35%", marginTop: "1em" }}>
          <CustomTextField
            style={{ backgroundColor: "white" }}
            placeholder="Search"
            className="custom-search-field"
            variant="outlined"
            size="small"
            onChange={handleInputChange}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
        </div>
        {/* <Button
          onClick={handleDownload}
          type="submit"
          variant="contained"
          color="primary"
          style={{
            backgroundColor: "#4f2d7f",
            color: "white",
            marginTop: "1.6em",
            marginLeft: "1em",
            height: "32px",
            fontSize: "12px",
            textTransform: "capitalize",
          }}
        >
          <img
            src={downloadWhite}
            alt="Download"
            style={{
              width: "30px",
              height: "20px",
              paddingBottom: "3px",
            }}
          />
        </Button> */}
        <input
          type="file"
          name="upfile"
          // accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          accept=".xlsx,.xls,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
          onChange={onFileSelected}
          ref={inputRef}
          onClick={(event) => {
            event.target.value = null;
          }}
          style={{ display: "none" }}
        />
        <Button
          onClick={onUploadButton}
          type="submit"
          variant="contained"
          color="primary"
          style={{
            backgroundColor: "#4f2d7f",
            color: "white",
            marginTop: "1.6em",
            marginLeft: "1em",
            height: "32px",
            fontSize: "12px",
            paddingRight: "2.3em",
            textTransform: "capitalize",
          }}
        >
          <img
            src={uploadWhite}
            alt="Download"
            style={{
              width: "30px",
              height: "20px",
              paddingBottom: "3px",
            }}
          />
          Upload
        </Button>
      </div>
      <Table handlePageClick={handlePageClick} />
    </>
  );
};

export default UploadReport;
